(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  // Grouped collection landing pages: crossfades a fixed background layer between
  // each category's assigned color as it scrolls through the middle of the viewport.
  // No-op on standard collection pages, since #collection-all-bg only exists on
  // category landing pages.
  (function () {
    const bg = document.getElementById('collection-all-bg');
    const categories = document.querySelectorAll('.collection-all-category[data-bg-color]');
    if (!bg || !categories.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const color = entry.target.getAttribute('data-bg-color');
            if (color) bg.style.backgroundColor = color;
          }
        });
      },
      { rootMargin: '-50% 0px -50% 0px', threshold: 0 }
    );

    categories.forEach((category) => observer.observe(category));
  })();

  } catch(e) { console.error(e); }
})();
})();
